import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LIST_PATH } from './activity/utils/listQuery';

/**
 * 旧地址兼容：司机活动已从一级菜单「司机运营」挪到「合作商管控」下（2026-11），
 * `/driver-ops`、`/driver-ops/activity/...` 重定向到 `/partner-control/driver-activity/...`，保留查询参数，书签与历史链接不失效。
 */
const DriverOpsRoutes: React.FC = () => {
    const location = useLocation();
    const rest = location.pathname.replace(/^\/driver-ops\/?(activity)?/, '');
    return <Navigate to={`${LIST_PATH}${rest}${location.search}`} replace />;
};

export default DriverOpsRoutes;
